/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Target_Days_RequiredInputs */



/**
* | output |
* | --- |
* | "Target days are required when duplicating to other days" |
*
* @param {Planning_Target_Days_RequiredInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const planning_target_days_required = /** @type {((inputs?: Planning_Target_Days_RequiredInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Target_Days_RequiredInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Target days are required when duplicating to other days")
	return /** @type {LocalizedString} */ ("Des jours cibles sont requis lorsque vous dupliquez vers d'autres jours")
});